import { useTranslation } from 'react-i18next';

/**
 * Banner promoting Clew, shown permanently (no dismiss) on the landing page and
 * on the project screen (ProjectSetup), since returning users skip the landing page.
 *
 * Imports only i18n so the landing page stays light (see LandingPage.tsx).
 */

/** Clew: the more advanced sibling app, under active development. yaqat itself is not retired. */
const CLEW_URL = 'https://clew.alefa.net/';

export function ClewNotice({ className = '' }: { className?: string }) {
  const { t } = useTranslation();
  return (
    <aside
      role="note"
      className={`rounded-lg border border-blue-200 bg-blue-50 px-4 py-3 text-sm leading-relaxed text-gray-800 dark:border-blue-900 dark:bg-blue-950 dark:text-gray-200 ${className}`}
    >
      {/* Link runs inline after the text so it wraps naturally at any width. */}
      <p>
        {t('landing.clew.text')}{' '}
        <a
          href={CLEW_URL}
          className="whitespace-nowrap font-medium text-blue-700 hover:underline dark:text-blue-300"
        >
          {t('landing.clew.link')}
        </a>
      </p>
    </aside>
  );
}
